export default "__VITE_ASSET__DjTK75ZH__"